import { Core } from "@faire/design-tokens";
import { Column } from "@faire/web--source/slate/Layout";
import styled, { css } from "styled-components";
import { NameAndMore } from "@faire/retailer/components/LeanBrandTileRenderer/__internal__/NameAndMore";
var LeanBrandTileWrapper = styled(Column).withConfig({
    componentId: "sc-88c58a43-0"
})([
    "width:100%;height:100%;position:relative;background-color:",
    ";",
    ";"
], Core.surface.inverse, function(props) {
    return props.$border ? css([
        "border:1px solid ",
        ";"
    ], Core.border.muted) : "";
});
var StyledNameAndMore = styled(NameAndMore).withConfig({
    componentId: "sc-88c58a43-1"
})([
    ""
]);
export var LeanBrandTileStyles;
(function(LeanBrandTileStyles) {
    LeanBrandTileStyles.Wrapper = LeanBrandTileWrapper;
    LeanBrandTileStyles.NameAndMore = StyledNameAndMore;
})(LeanBrandTileStyles || (LeanBrandTileStyles = {}));
